import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57863841"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OTabelaProfissionais" }
const _hoisted_2 = { class: "OTabelaProfissionais__Perfil" }
const _hoisted_3 = { class: "OTabelaProfissionais__NomeEmail" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "ajustar-textos-longos" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" o profissional e seu usuário de acesso serão permanentemente removidos do sistema e não será possível recuperá-los ")

import { computed, ref, onMounted } from "vue"
  import { ToastSeverity } from "primevue/api"
  import { ToastMessageOptions } from "primevue/toast"

  // tipos e estados
  import { Anulavel } from "@/types/gerais"
  import { estados } from "@/types/api"
  import { Erro } from "@/repositorios/erros"

  // componentes
  import Avatar from "primevue/avatar"
  import Column from "primevue/column"
  import DataTable, { DataTableFilterMeta } from "primevue/datatable"
  import PButton from "primevue/button"
  import { PageState } from "primevue/paginator"
  import {
    MInput,
    MModalDeAlerta,
    AEstadoVazioTabela,
    APaginadorDeTabela,
  } from "@/components/Gerais"

  // composables
  import { useRouter } from "vue-router"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarFiltragem } from "@/composable/UsarFiltragem"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import { useToast } from "primevue/usetoast"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  import { usarFoto } from "@/composable/UsarFoto/usarFoto"
  // profissionais
  import { usarManipuladoresDeTabela } from "@/composable/UsarManipuladoresDeTabela/usarManipuladoresDeTabela"
  import tabelaProfissionais from "./OTabelaProfissionais.script"
  import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
  import {
    ListarProfissionais,
    ParamsProfissional,
  } from "@/repositorios/profissional/profissional.modelo"

  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { useI18n } from "vue-i18n"

  interface Props {
    destino?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaProfissionais',
  props: {
    destino: null
  },
  setup(__props: any) {

  // framework cores
  

  const { t } = useI18n()

  const PRIMEIRA_PAGINA_PADRAO = 0
  const ALTURA_RELATIVA_DA_TABELA = "calc(100vh - 265px)"

  const abrirModalConfirmacao = ref(false)

  const profissionalRep = new ProfissionalRepositorio()

  const { desativarLinhaPorStatus } = usarManipuladoresDeTabela()
  const { filtrosTabelaProfissionais } = tabelaProfissionais()

  const profissionais = ref<ListarProfissionais[]>([])
  const idProfissionalDeletar = ref<Anulavel<string>>()
  const nomeProfissionalDeletar = ref<Anulavel<string>>(null)
  const estagioDaRequisicao = ref<number>(estados.INICIAL)
  const estagioDeCarregamentoDaTabela = ref<number>(estados.INICIAL)
  const toast = useToast()
  const router = useRouter()
  const {
    filtros: filtrosComposable,
    preencherFiltro,
    removerFiltro,
  } = usarFiltragem()

  const { verificarPermissaoPorGrupo } = usarPermissionamento("Profissionais")
  const { pegarIniciais } = usarFuncoesStrings()
  const { leitor } = usarLeitorDeDados()
  const { escritor } = usarEscritorDeDados()

  const lerProfissionais = leitor<ListarProfissionais, ParamsProfissional>(
    profissionalRep.listarProfissionaisFrontend
  )

  const removerProfissional = escritor<void, string, void>(
    profissionalRep.deletarProfissional,
    ["", undefined]
  )
  const desativarProfissional = escritor<{ id: string }, string, void>(
    profissionalRep.arquivarProfissional,
    ["", undefined]
  )
  const ativarProfissional = escritor<{ id: string }, string, void>(
    profissionalRep.desarquivarProfissional,
    ["", undefined]
  )

  const carregando = computed(() => {
    return estagioDaRequisicao.value === estados.PEDENTE
  })
  const estaCarregandoProfissionais = computed(
    () => estagioDeCarregamentoDaTabela.value === estados.PEDENTE
  )
  const cabecalhoModal = computed(
    () => "excluir " + '"' + nomeProfissionalDeletar.value + '"' + "?"
  )
  const { obterUrlFotoProfissional } = usarFoto()
  const fotoOuIniciais = (foto: string, nome: string): string | undefined => {
    if (foto) {
      return undefined
    } else {
      return pegarIniciais(nome)
    }
  }

  const mostrarEmailOuAviso = (email: string): string => {
    if (email) {
      return email
    } else {
      return "email não informado"
    }
  }

  const irParaEditarProfissional = (idProfissional: string): void => {
    router.push("/profissionais/editar-profissional/" + idProfissional)
  }

  const solicitarRemocaoDeProfissional = (
    idProfissional: Anulavel<string>,
    nomeProfissional: Anulavel<string>
  ): void => {
    idProfissionalDeletar.value = idProfissional
    nomeProfissionalDeletar.value = nomeProfissional

    abrirModalConfirmacao.value = true
  }
  const onSucesso = (detalhes: string, titulo: string): void => {
    estagioDaRequisicao.value = estados.SUCESSO

    const mensagem: ToastMessageOptions = {
      severity: ToastSeverity.SUCCESS,
      summary: titulo,
      detail: detalhes,
      life: 4000,
    }
    toast.add(mensagem)

    abrirModalConfirmacao.value = false
  }
  const onErro = (erro: Erro): void => {
    const mensagem: ToastMessageOptions = {
      severity: ToastSeverity.ERROR,
      summary: erro.mensagem,
      detail: erro.detalhe,
      life: 4000,
    }
    toast.add(mensagem)

    estagioDaRequisicao.value = estados.ERRO
  }
  const deletarProfissional = async (): Promise<void> => {
    if (idProfissionalDeletar.value) {
      estagioDaRequisicao.value = estados.PEDENTE

      removerProfissional.mudarArgumentos([
        idProfissionalDeletar.value,
        undefined,
      ])
      await removerProfissional.executar()

      if (removerProfissional.resultado.status == "sucesso") {
        onSucesso(
          "o profissional " + nomeProfissionalDeletar.value + " foi deletado",
          "Profissional deletado"
        )
        listarProfissionais(lerProfissionais.paginaAtual)
      }

      if (removerProfissional.resultado.status === "erro") {
        onErro({
          mensagem: t("ocorreuUmErro"),
          detalhe: t("naoFoiPossivelRemoverProfissional"),
          tipo: "erro",
        })
      }
    }
  }

  const atualizarStatusDoProfissionalNaTabela = ({
    id,
    novoStatus,
  }: {
    id: string
    novoStatus: boolean
  }): void => {
    const profissional = profissionais.value.find(
      (profissionalFiltrado) => profissionalFiltrado.id === id
    )

    if (profissional) {
      profissional.ativo = novoStatus
    }
  }

  const arquivarProfissional = async (
    idProfissional: string
  ): Promise<void> => {
    desativarProfissional.mudarArgumentos([idProfissional, undefined])
    await desativarProfissional.executar()

    if (desativarProfissional.resultado.status == "sucesso") {
      atualizarStatusDoProfissionalNaTabela({
        ...desativarProfissional.resultado.dados,
        novoStatus: false,
      })
    }
  }

  const desarquivarProfissional = async (
    idProfissional: string
  ): Promise<void> => {
    ativarProfissional.mudarArgumentos([idProfissional, undefined])
    await ativarProfissional.executar()

    if (ativarProfissional.resultado.status === "sucesso") {
      atualizarStatusDoProfissionalNaTabela({
        ...ativarProfissional.resultado.dados,
        novoStatus: true,
      })
    }
  }


  const listarProfissionais = async (
    pagina: number,
    porPagina = 10
  ): Promise<void> => {
    estagioDeCarregamentoDaTabela.value = estados.PEDENTE
    await lerProfissionais.porPagina(porPagina).pagina(pagina).executar()
    const statusDaRequisicao = lerProfissionais.resultado.status

    if (statusDaRequisicao === "vazio") {
      profissionais.value = []
    }

    if (statusDaRequisicao === "sucesso") {
      profissionais.value = await Promise.all(
        lerProfissionais.resultado.dados.map(async (profissional) => {
          if (profissional.urlFotoDeAvatar) {
            return {
              ...profissional,
              fotoDeAvatar: await obterUrlFotoProfissional(
                profissional.urlFotoDeAvatar
              ),
            }
          } else {
            return { ...profissional, fotoDeAvatar: "" }
          }
        })
      )
    }

    estagioDeCarregamentoDaTabela.value = estados.SUCESSO
  }

  const filtrarProfissionais = async (): Promise<void> => {
    lerProfissionais.sobrescreverParametros({
      ...filtrosComposable.value,
    })

    lerProfissionais.primeiraPagina = PRIMEIRA_PAGINA_PADRAO
    await listarProfissionais(
      lerProfissionais.primeiraPagina,
      lerProfissionais.itensPorPagina
    )
  }

  const onPaginarProfessores = async ({
    page,
    rows,
  }: PageState): Promise<void> => {
    await listarProfissionais(page, rows)
  }

  const aplicarFiltros = async (
    dadosDoPreenchimentoDoFiltro: Record<string, unknown>,
    nomeDaColunaNaAPI: string
  ): Promise<void> => {
    const { matchMode, value } = (
      dadosDoPreenchimentoDoFiltro as DataTableFilterMeta
    ).constraints[0]

    preencherFiltro(nomeDaColunaNaAPI, matchMode, value)

    filtrarProfissionais()
  }

  const limparFiltros = async (nome, filterCallback): Promise<void> => {
    removerFiltro(nome)
    filterCallback()
    filtrarProfissionais()
  }

  onMounted(() => {
    listarProfissionais(lerProfissionais.primeiraPagina)
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      "onUpdate:filters": filtrarProfissionais,
      class: "OTabelaProfissionais p-datatable-sm",
      "data-key": "codigo",
      "data-testid": "OTabelaProfissionais",
      "filter-display": "menu",
      filters: _unref(filtrosTabelaProfissionais),
      "global-filters-fields": ['nome', 'codigo', 'responsaveis'],
      loading: _unref(estaCarregandoProfissionais),
      "responsive-layout": "scroll",
      "row-class": _unref(desativarLinhaPorStatus),
      rows: _unref(lerProfissionais).itensPorPagina,
      "scroll-height": ALTURA_RELATIVA_DA_TABELA,
      scrollable: "",
      "striped-rows:value": "profissionais",
      value: profissionais.value
    }, _createSlots({
      loading: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          height: "100%",
          width: "100%"
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(APaginadorDeTabela), {
          "ao-paginar": onPaginarProfessores,
          leitor: _unref(lerProfissionais)
        }, null, 8, ["leitor"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          class: "OTabelaProfissionais__Column",
          field: "nome",
          header: _unref(t)('nome'),
          "show-add-button": false,
          "show-filter-operator": false,
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Avatar), {
                class: "OTabelaProfissionais__Avatar",
                "data-testid": "OTabelaProfissionais__Avatar",
                image: data.fotoDeAvatar,
                label: fotoOuIniciais(data.fotoDeAvatar, data.nome),
                shape: "circle"
              }, null, 8, ["image", "label"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", {
                  class: "quebrar-texto-em-duas-linhas",
                  title: data.nome
                }, _toDisplayString(data.nome), 9, _hoisted_4),
                _createElementVNode("small", null, _toDisplayString(mostrarEmailOuAviso(data.usuarioRelacionado?.email)), 1)
              ])
            ])
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MInput), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              nome: "filtro-nome-do-profissional",
              placeholder: _unref(t)('pesquisarPorNomeDoProfissional'),
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ field, filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros(field, filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          class: "OTabelaProfissionais__Column",
          field: "codigo",
          header: _unref(t)('codigo'),
          "show-add-button": false,
          "show-filter-operator": false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(data.codigo), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MInput), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              nome: "filtro-codigo",
              placeholder: _unref(t)('pesquisarPorCodigoDoProfissional'),
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ field, filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros(field, filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          class: "OTabelaProfissionais__Column OTabelaProfissionais__Acoes",
          field: "acoes",
          "show-add-button": false,
          "show-filter-operator": false,
          style: {"flex":"0"}
        }, {
          body: _withCtx(({ data }) => [
            (_unref(verificarPermissaoPorGrupo)('editar', 'ambos'))
              ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                  key: 0,
                  onClick: ($event: any) => (irParaEditarProfissional(data.id)),
                  class: "OTabelaProfissionais__IButton p-button-rounded",
                  "data-testid": "OTabelaProfissionais__IButton",
                  icon: "pi pi-pencil"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('editar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (!data.ativo && _unref(verificarPermissaoPorGrupo)('deletar', 'ambos'))
              ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                  key: 1,
                  onClick: ($event: any) => (solicitarRemocaoDeProfissional(data.id, data.nome)),
                  class: "OTabelaProfissionais__IButton p-button-rounded",
                  "data-testid": "OTabelaProfissionais__SolicitarRemocao",
                  icon: "pi pi-trash"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('deletar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (data.ativo && _unref(verificarPermissaoPorGrupo)('arquivar', 'ambos'))
              ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                  key: 2,
                  onClick: ($event: any) => (arquivarProfissional(data.id)),
                  class: "OTabelaProfissionais__IButton p-button-rounded",
                  "data-testid": "OTabelaProfissionais__Arquivar",
                  icon: "pi pi-eye-slash"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('arquivar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (
              !data.ativo && _unref(verificarPermissaoPorGrupo)('desarquivar', 'ambos')
            )
              ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                  key: 3,
                  onClick: ($event: any) => (desarquivarProfissional(data.id)),
                  class: "OTabelaProfissionais__IButton p-button-rounded",
                  "data-testid": "OTabelaProfissionais__IButton",
                  icon: "pi pi-eye"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('desarquivar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      (!_unref(estaCarregandoProfissionais))
        ? {
            name: "empty",
            fn: _withCtx(() => [
              _createVNode(_unref(AEstadoVazioTabela))
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["filters", "loading", "row-class", "rows", "value"]),
    _createVNode(_unref(MModalDeAlerta), {
      modelValue: abrirModalConfirmacao.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((abrirModalConfirmacao).value = $event)),
      cabecalho: _unref(cabecalhoModal),
      "data-testid": "OTabelaProfissionais__Alerta",
      destino: __props.destino,
      fechavel: !_unref(carregando),
      icone: "pi pi-exclamation-triangle"
    }, {
      conteudo: _withCtx(() => [
        _hoisted_6
      ]),
      acoes: _withCtx(() => [
        _createVNode(_unref(PButton), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (abrirModalConfirmacao.value = false)),
          class: "OTabelaProfissionais__FecharModal p-button-text",
          "data-testid": "OTabelaProfissionais__FecharModal",
          disabled: _unref(carregando),
          label: "não"
        }, null, 8, ["disabled"]),
        _createVNode(_unref(PButton), {
          onClick: deletarProfissional,
          class: "OTabelaProfissionais__DeletarProfissional p-button-danger",
          "data-testid": "OTabelaProfissionais__DeletarProfissional",
          disabled: _unref(carregando),
          label: "sim, excluir",
          loading: _unref(carregando)
        }, null, 8, ["disabled", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue", "cabecalho", "destino", "fechavel"])
  ]))
}
}

})